import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type ContactTextConsentFragment = { __typename?: 'ContactTextConsentData', contactId: string, phoneNumber: string, status: Types.ContactTextConsentStatus, requestExpiresAt?: Types.TDateISO | null, stoppedAt?: Types.TDateISO | null, repliedStopAt?: Types.TDateISO | null, lastTextFailed: boolean };

export type GetCustomerTextConsentsQueryVariables = Types.Exact<{
  customerId: Types.Scalars['String']['input'];
}>;


export type GetCustomerTextConsentsQuery = { __typename?: 'Query', customerTextConsents: Array<{ __typename?: 'ContactTextConsentData', contactId: string, phoneNumber: string, status: Types.ContactTextConsentStatus, requestExpiresAt?: Types.TDateISO | null, stoppedAt?: Types.TDateISO | null, repliedStopAt?: Types.TDateISO | null, lastTextFailed: boolean }> };

export type GetCustomerTextConsentWordingQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCustomerTextConsentWordingQuery = { __typename?: 'Query', customerTextConsentWording?: { __typename?: 'CustomerTextConsentWordingData', version: number, wording: string, yesRequestText: string } | null };

export const ContactTextConsentFragmentDoc = new TypedDocumentString(`
    fragment ContactTextConsent on ContactTextConsentData {
  contactId
  phoneNumber
  status
  requestExpiresAt
  stoppedAt
  repliedStopAt
  lastTextFailed
}
    `, {"fragmentName":"ContactTextConsent"});
export const GetCustomerTextConsentsDocument = new TypedDocumentString(`
    query GetCustomerTextConsents($customerId: String!) {
  customerTextConsents(customerId: $customerId) {
    ...ContactTextConsent
  }
}
    fragment ContactTextConsent on ContactTextConsentData {
  contactId
  phoneNumber
  status
  requestExpiresAt
  stoppedAt
  repliedStopAt
  lastTextFailed
}`);
export const GetCustomerTextConsentWordingDocument = new TypedDocumentString(`
    query GetCustomerTextConsentWording {
  customerTextConsentWording {
    version
    wording
    yesRequestText
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetCustomerTextConsents: build.query<GetCustomerTextConsentsQuery, GetCustomerTextConsentsQueryVariables>({
      query: (variables) => ({ document: GetCustomerTextConsentsDocument, variables })
    }),
    GetCustomerTextConsentWording: build.query<GetCustomerTextConsentWordingQuery, GetCustomerTextConsentWordingQueryVariables | void>({
      query: (variables) => ({ document: GetCustomerTextConsentWordingDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetCustomerTextConsentsQuery, useLazyGetCustomerTextConsentsQuery, useGetCustomerTextConsentWordingQuery, useLazyGetCustomerTextConsentWordingQuery } = injectedRtkApi;
